var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import styled from 'styled-components';
var PanelBody = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  overflow: auto;\n  flex: 1;\n"])));
export default PanelBody;